var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.423911 11.5717L5.95399 13.6357L8.09447 20.5195C8.23143 20.9604 8.77055 21.1233 9.12839 20.8308L12.211 18.3178C12.5341 18.0545 12.9943 18.0414 13.332 18.2865L18.8918 22.3231C19.2746 22.6013 19.817 22.3916 19.913 21.929L23.9858 2.33774C24.0906 1.83246 23.5942 1.41094 23.113 1.59702L0.417431 10.3523C-0.142649 10.5683 -0.137769 11.3613 0.423911 11.5717ZM7.74951 12.537L18.5574 5.88046C18.7516 5.76118 18.9514 6.02382 18.7846 6.17854L9.86503 14.4697C9.55151 14.7616 9.34927 15.1521 9.29199 15.5761L8.98815 17.8277C8.94791 18.1284 8.52559 18.1582 8.44263 17.8673L7.27407 13.7613C7.14023 13.2929 7.33527 12.7927 7.74951 12.537Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f8a6844bf5a9f00912558d84e120a98f.svg";
export { ForwardRef as ReactComponent };